<template>
  <v-tooltip bottom :disabled="!tooltip">
    <span>{{ tooltip }}</span>
    <template v-slot:activator="{ on, attrs }">
      <svg
        v-bind="attrs"
        v-on="on"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        :width="size"
        :height="size"
        viewBox="0 0 64 64"
      >
        <g stroke-width="4" transform="translate(0, 0)">
          <line
            data-cap="butt"
            data-color="color-2"
            fill="none"
            :stroke="color"
            stroke-width="4"
            stroke-miterlimit="10"
            x1="26.7"
            y1="24.481"
            x2="17.3"
            y2="39.519"
            stroke-linejoin="miter"
            stroke-linecap="butt"
          ></line>
          <line
            data-cap="butt"
            data-color="color-2"
            fill="none"
            :stroke="color"
            stroke-width="4"
            stroke-miterlimit="10"
            x1="37.3"
            y1="24.481"
            x2="46.7"
            y2="39.519"
            stroke-linejoin="miter"
            stroke-linecap="butt"
          ></line>
          <line
            data-cap="butt"
            data-color="color-2"
            fill="none"
            :stroke="color"
            stroke-width="4"
            stroke-miterlimit="10"
            x1="22"
            y1="48"
            x2="42"
            y2="48"
            stroke-linejoin="miter"
            stroke-linecap="butt"
          ></line>
          <circle
            fill="none"
            :stroke="color"
            stroke-width="4"
            stroke-linecap="square"
            stroke-miterlimit="10"
            cx="12"
            cy="48"
            r="10"
            stroke-linejoin="miter"
          ></circle>
          <circle
            fill="none"
            :stroke="color"
            stroke-width="4"
            stroke-linecap="square"
            stroke-miterlimit="10"
            cx="52"
            cy="48"
            r="10"
            stroke-linejoin="miter"
          ></circle>
          <circle
            fill="none"
            :stroke="color"
            stroke-width="4"
            stroke-linecap="square"
            stroke-miterlimit="10"
            cx="32"
            cy="16"
            r="10"
            stroke-linejoin="miter"
          ></circle>
        </g>
      </svg>
    </template>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "ConnectIcon",
  props: {
    size: {
      type: String,
      default: "1em",
    },
    color: {
      type: String,
      default: "#444",
    },
    tooltip: {
      type: String,
      default: "",
    },
  },
})
</script>
<script setup lang="ts"></script>
